export default "__VITE_ASSET__BGZuKgp9__"